(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundles"] && !Shopify.designMode) return;
  try {
    
  const injectElements = () => {
    const productGridPadding = document.querySelector('[class*="product-grid-padding"]')
    const bundleCard = document.querySelector('#lm-bundle-card')

    productGridPadding.querySelectorAll('.page-width').forEach(elem => {
      elem.classList.remove('page-width')
    })

    productGridPadding.classList.add('page-width')
    productGridPadding.insertAdjacentElement('afterbegin', bundleCard)
  }
  injectElements()
  
  const adjustProductForms = () => {  
    document.querySelectorAll('.collection product-form').forEach(productForm => {
      var newProductForm = document.createElement('lm-bundle-product-form')
      newProductForm.innerHTML = productForm.innerHTML

      productForm.parentNode.replaceChild(newProductForm, productForm)
    })
  }
  adjustProductForms()

  const adjustQuickViewContents = () => {
    const quickAddModal = document.querySelector('quick-add-modal')
      
      const observer = new MutationObserver((mutations) => { 
        setTimeout(() => {
          const productForm = quickAddModal.querySelector('product-form')
          if (!productForm) return

          var newProductForm = document.createElement('lm-bundle-product-form')
          newProductForm.innerHTML = productForm.innerHTML

          productForm.parentNode.replaceChild(newProductForm, productForm)
        }, 500)
      })

      observer.observe(quickAddModal, { 
        attributes: true
      });
  }
  adjustQuickViewContents()

  const reInitAfterAjaxLoad = () => {
    const wrapper = document.querySelector('.collection')

    const observer = new MutationObserver(async (mutations) => {
      setTimeout(() => {
        const productGridPadding = document.querySelector('[class*="product-grid-padding"]')
        
        productGridPadding.querySelectorAll('.page-width').forEach(elem => {
          elem.classList.remove('page-width')
        }) 
        
        adjustProductForms()
        reInitAfterAjaxLoad()
      }, 500)

    })

    observer.observe(wrapper, { 
      attributes: true,
      childList: true,
    });
  }
  reInitAfterAjaxLoad()

  class LmBundleProductForm extends HTMLElement {
    constructor () {
      super()

      setTimeout(() => {
        this.form = this.querySelector('form')
        this.btn = this.querySelector('button[name="add"]')
        this.quickAddModal = this.closest('.quick-add-modal')

        this.form.addEventListener('submit', this.onSubmit.bind(this))
        this.adjustBtn()
        this.handleVariantChange()
      }, 50)
    }

    adjustBtn () {
      if (!this.btn.disabled) {
        this.btn.querySelector('span').textContent = window.lm_bundle_builder.text.add_to_bundle
      }
    }

    handleVariantChange () {
      if (this.quickAddModal) {
        this.quickAddModal.querySelectorAll('variant-selects input').forEach(input => {
          input.addEventListener('change', () => {
            this.btn.style.opacity = '.1'

            setTimeout(() => {
              this.adjustBtn()
              this.btn.style.opacity = '1'
            }, 500)
          })
        })
      }
    }

    async onSubmit (event) {
      event.preventDefault()
         
      this.btn.classList.add('loading')
      this.btn.querySelector('.loading__spinner').classList.remove('hidden') 

      const variantId = Number(this.form.querySelector('[name="id"]').value)

      const bundleContents = JSON.parse(localStorage.getItem('lm-bundle-contents')) || []

      const isInBundleContents = bundleContents.some((item) => item.variant_id === variantId)

      let qty = 1

      if (this.quickAddModal) {
        const qtyFeield = this.quickAddModal.querySelector('input[name="quantity"]')

        if (qtyFeield) {
          qty = Number(qtyFeield.value)
        }
      }

      if (isInBundleContents) {
        bundleContents.map(item => {
          if (item.variant_id === variantId) {
            item.quantity += qty
          }
          return item
        })
      } else {
        let productLink 
      
        if (this.quickAddModal) {
          productLink = this.closest('.product').querySelector('a[href*="products"]').getAttribute('href') 
        } else {
          productLink = this.closest('.card').querySelector('a[href*="products"]').getAttribute('href') 
        }

        productLink = productLink.replace(/(\?.*)|(#.*)/g, "")

        const response = await fetch(`${productLink}.js`)
        const product = await response.json()
        console.log(product)

        const variant = product.variants.find(variant => variant.id === variantId)
        console.log(variant)

        bundleContents.push({
          product_id: product.id,
          product_handle: product.handle,
          product_title: product.title,
          product_image: product.featured_image,
          variant_id: variant.id,
          variant_title: variant.title,
          variant_price: variant.price, 
          variant_compare_at_price: variant.compare_at_price,
          variant_image: variant.featured_image ? variant.featured_image.src : null,
          quantity: qty
        })
      }

      console.log(bundleContents)

      localStorage.setItem('lm-bundle-contents', JSON.stringify(bundleContents))

      this.btn.querySelector('span').textContent = window.lm_bundle_builder.text.added_to_bundle
      this.btn.classList.remove('loading')
      this.btn.querySelector('.loading__spinner').classList.add('hidden') 
      
      window.dispatchEvent(new CustomEvent('lm_bundle_builder_add_to_bundle'))

      setTimeout(() => {
        this.quickAddModal?.hide()
      }, 1000)

      setTimeout(() => {
        this.btn.querySelector('span').textContent = window.lm_bundle_builder.text.add_to_bundle

        this.quickAddModal?.hide()
      }, 2000)
    }
  }
  customElements.define('lm-bundle-product-form', LmBundleProductForm)

  class LmBundleCard extends HTMLElement {
    constructor () {
      super ()
  
      this.updateContents()
      this.fixStickyPosition()

      window.addEventListener('lm_bundle_builder_add_to_bundle', () => {
        this.updateContents()
      })

      document.querySelectorAll('.lm-btn-atc').forEach(btn => {
        btn.addEventListener('click', () => {
          this.onAddToCart(btn)
        })
      })
    }

    getBundleContents () {
      return JSON.parse(localStorage.getItem('lm-bundle-contents')) || []
    }

    getTotalPrice () {
      return this.getBundleContents().reduce((accumulator, currentValue) =>
        (currentValue.variant_price * currentValue.quantity) + accumulator, 0)
    }

    updateContents () {
      const totalPrice = this.getTotalPrice()
      const progressBar = this.querySelector('.progress-bar') 
      const progressText = this.querySelector('.progress-text') 
      const tiers = window.lm_bundle_builder.tiers
      const maxTierGoal = window.lm_bundle_builder.max_tier_goal
      let progressWidth = Math.round(totalPrice / maxTierGoal * 100)

      if (progressWidth > 100) progressWidth = 100
      
      setTimeout(() => {
        progressBar.style.width = `${progressWidth}%`

        if (progressWidth >= 100) {
          progressBar.style.backgroundColor = progressBar.dataset.colorCompleted
        } else {
          progressBar.style.backgroundColor = progressBar.dataset.colorNotCompleted 
        }
      }, 200)

      if (totalPrice <= maxTierGoal) {
        const tier = tiers.find(elem => elem.goal > totalPrice)
        const remaining = this.formatMoney(tier.goal - totalPrice).replace('.00', '')
        const discount = tier.discount + '%' 
        let textUncompleted = progressText.dataset.textUncompleted
        textUncompleted = textUncompleted.replace('[value]', `<b>${remaining}</b>`)
        textUncompleted = textUncompleted.replace('[discount]', `<b>${discount}</b>`)
        progressText.innerHTML = textUncompleted
        progressText.style.color = ''
      } else {
        const discount = tiers[tiers.length - 1].discount + '%'

        let textCompleted = progressText.dataset.textCompleted
        textCompleted = textCompleted.replace('[discount]', `<b>${discount}</b>`)
        progressText.innerHTML = textCompleted
        progressText.style.color = progressBar.dataset.colorCompleted
      }

      document.querySelectorAll('[data-lm-bundle-price]').forEach(elem => {
        const tier = tiers.slice().reverse().find(elem => elem.goal <= totalPrice)

        if (tier) {
          const compareAtPrice = this.formatMoney(totalPrice)
          const price = this.formatMoney((1 - (tier.discount / 100)) * totalPrice)
          elem.innerHTML = `
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <s>${compareAtPrice}</s> 
            <span class="visually-hidden visually-hidden--inline">Sale price</span>
            <b>${price}</b>
          `
        } else {
          elem.innerHTML = this.formatMoney(totalPrice)
        }
      })

      document.querySelectorAll('[data-lm-bundle-discount]').forEach(elem => {
        const tier = tiers.slice().reverse().find(elem => elem.goal <= totalPrice)

        const tierDiscount = tier?.discount || 0

        const savings = this.formatMoney(tierDiscount / 100 * totalPrice)
        elem.innerHTML = `${savings} (${tierDiscount}%)`
      }) 

      document.querySelectorAll('.lm-btn-view-contents').forEach(elem => {
        elem.disabled = totalPrice === 0
      })

      document.querySelectorAll('.lm-btn-atc').forEach(elem => {
        elem.disabled = totalPrice === 0
      })
    } 

    async onAddToCart (btn) {
      btn.classList.add('loading')
      btn.querySelector('.loading__spinner').classList.remove('hidden') 

      const items = this.getBundleContents().reduce((accumulator, currentValue) => {
        accumulator.push({
          id: currentValue.variant_id,
          quantity: currentValue.quantity
        })
        return accumulator
      }, []) 

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
      let sections = cart.getSectionsToRender().map((section) => section.id)

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items, sections })
      })
      const responseData = await response.json()

      localStorage.removeItem('lm-bundle-contents')
      this.updateContents()

      if (btn.dataset.redirectToCheckout === 'true') {
        window.location.href = '/checkout'
        return
      }

      btn.classList.remove('loading')
      btn.querySelector('.loading__spinner').classList.add('hidden')
      
      document.querySelector('#lm-bundle-dialog')?.close()
      
      cart.renderContents(responseData)
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty')
    }

    fixStickyPosition () {
      const elem = this.querySelector('.lm-inner-content')
      let oldScroll = window.scrollY

      window.addEventListener('scroll', (event) => {
        if (!document.querySelector('.shopify-section-header-sticky')) return
  
        const newScroll = window.scrollY

        if (newScroll > oldScroll) {
          elem.style.top = '1.5rem'
        } else if (newScroll < oldScroll) {
          elem.style.top = 'calc(var(--header-height) + 1.5rem)'
        }

        oldScroll = Math.max(window.scrollY, 0)
      })
    }

    formatMoney (cents, moneyFormat = this.dataset.moneyFormat) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '')
      }

      let value = ''
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/

      function defaultOption (opt, def) {
        return (typeof opt === 'undefined' ? def : opt)
      }

      function formatWithDelimiters (number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2)
        thousands = defaultOption(thousands, ',')
        decimal = defaultOption(decimal, '.')

        if (isNaN(number) || number == null) {
          return 0
        }

        number = (number / 100.0).toFixed(precision)

        const parts = number.split('.')
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
        const cents = parts[1] ? (decimal + parts[1]) : ''

        return dollars + cents
      }

      switch (moneyFormat.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2)
        break
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',')
        break
      }

      return moneyFormat.replace(placeholderRegex, value)
    }
  }
  customElements.define('lm-bundle-card', LmBundleCard)

  class LmBundleStickyCard extends HTMLElement {
    constructor () {
      super()

      const bundleCard = document.querySelector('#lm-bundle-card')

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.remove('show')
          } else {
            this.classList.add('show')
          }
        })
      }, { threshold: 0 })

      observer.observe(bundleCard)
    }
  }
  customElements.define('lm-bundle-sticky-card', LmBundleStickyCard)

  class LmBundleDialog extends HTMLElement {
    constructor () {
      super()

      this.dialog = this.querySelector('dialog')

      document.querySelectorAll('.lm-btn-view-contents').forEach(btn => {
        btn.addEventListener('click', () => {
          this.dialog.showModal()
          document.querySelector('body').classList.add('overflow-hidden')
        })
      })

      // Close dialog if clicked outside
      this.dialog.addEventListener('click', (event) => {
        const withinBoundaries = event.composedPath().includes(this.dialog.querySelector('.lm-dialog-inner'))

        if (!withinBoundaries) {
          this.dialog.close()
        }
      })

      this.dialog.querySelector('data-dialog-close')?.addEventListener('click', (event) => {
        event.preventDefault()
        this.dialog.close()
      })

      this.dialog.addEventListener('close', (event) => {
        document.querySelector('body').classList.remove('overflow-hidden')
      })

      this.buildContents()

      window.addEventListener('lm_bundle_builder_add_to_bundle', () => {
        this.buildContents()
      })
    }

    getBundleContents () {
      return JSON.parse(localStorage.getItem('lm-bundle-contents')) || []
    }

    buildContents () {
      const wrapper = this.querySelector('.lm-bundle-contents')
      wrapper.innerHTML = ''

      let bundleContentsList = ''

      this.getBundleContents().forEach(elem => {
        const image = elem.variant_image || elem.product_image
      
        bundleContentsList += `
          <div class="lm-bundle-contents-item" role="listitem">
            <div class="lm-bundle-contents-item-left">
              <img 
                src="${this.resizeImage(image, `600x600`, 'center')}"
                class="" 
                alt="" 
                width="600" 
                height="600" 
                loading="lazy">
            </div>
            <div class="lm-bundle-contents-item-right">
              <h3 class="title h4">
                ${elem.product_title}
              </h3>
              <p class="lm-variant-title product-option" ${elem.variant_title === 'Default Title' ? 'hidden': ''}>
                ${elem.variant_title}
              </p>
              <p class="lm-variant-price product-option">
                ${document.querySelector('#lm-bundle-card').formatMoney(elem.variant_price)}
              </p>
              <div class="lm-quantity-wrapper">
                <quantity-input class="quantity">
                  <button class="quantity__button no-js-hidden disabled" name="minus" type="button">
                    <span class="visually-hidden">Decrease quantity</span>
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                    </svg>
                  </button>
                  <input 
                    class="quantity__input" 
                    type="number"
                    value="${elem.quantity}" 
                    min="1" 
                    step="1" 
                    aria-label="Quantity"
                    data-variant-id="${elem.variant_id}"
                    onchange="document.querySelector('lm-bundle-dialog').updateItemQty(this, event)">
                  <button class="quantity__button no-js-hidden" name="plus" type="button">
                    <span class="visually-hidden">Increase quantity</span>
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
                      </path>
                    </svg>
                  </button>
                </quantity-input>
                <button
                  type="button" 
                  class="button button--tertiary lm-remove-btn" 
                  aria-label="Remove" 
                  data-variant-id="${elem.variant_id}"
                  onclick="document.querySelector('lm-bundle-dialog').removeItem(this, event)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false" class="icon icon-remove">
                    <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                    <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ` 
      })

      wrapper.insertAdjacentHTML('afterbegin', bundleContentsList)
    }

    updateItemQty (input, event) {
      const variantId = Number(input.dataset.variantId)
      const newQty = Number(input.value)

      let bundleContents = this.getBundleContents()

      bundleContents.map(item => {
        if (item.variant_id === variantId) {
          item.quantity = newQty
        }
        return item
      })

      localStorage.setItem('lm-bundle-contents', JSON.stringify(bundleContents))
    
      this.buildContents()
      document.querySelector('#lm-bundle-card').updateContents()
    }

    removeItem (btn, event) {
      const variantId = Number(btn.dataset.variantId)

      let bundleContents = this.getBundleContents()

      bundleContents = bundleContents.filter(item => item.variant_id !== variantId)

      localStorage.setItem('lm-bundle-contents', JSON.stringify(bundleContents))
    
      this.buildContents()
      document.querySelector('#lm-bundle-card').updateContents()

      if (!bundleContents.length) {
        this.dialog.close()
      }
    }

    resizeImage = function (src, size, crop = '') {
      return src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
        .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
          if (crop.length) {
            crop = `_crop_${crop}`
          }
          return `_${size}${crop}${match}`
        })
    }
  }
  customElements.define('lm-bundle-dialog', LmBundleDialog)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gmy-hair"] && !Shopify.designMode) return;
  try {
    
function gmyShowHairSlide(section, index) {
  const slides = Array.from(section.querySelectorAll('[data-hair-slide]'));
  if (!slides.length) return;
  const current = (index + slides.length) % slides.length;
  slides.forEach((slide, i) => { slide.hidden = i !== current; });
  section.querySelectorAll('[data-hair-index]').forEach((button, i) => {
    button.setAttribute('aria-pressed', String(i === current));
  });
  const status = section.querySelector('[data-hair-status]');
  if (status) status.textContent = slides[current].getAttribute('aria-label');
}
function gmyMoveHairSlide(section, direction) {
  const slides = Array.from(section.querySelectorAll('[data-hair-slide]'));
  gmyShowHairSlide(section, slides.findIndex(slide => !slide.hidden) + direction);
}
document.addEventListener('click', event => {
  const button = event.target.closest('[data-hair-direction], [data-hair-index]');
  if (!button) return;
  const section = button.closest('[data-hair-carousel]');
  if (!section) return;
  if (button.hasAttribute('data-hair-index')) gmyShowHairSlide(section, Number(button.dataset.hairIndex));
  else gmyMoveHairSlide(section, Number(button.dataset.hairDirection));
});
document.addEventListener('keydown', event => {
  if (!event.target.closest('.gmy-hair-controls')) return;
  const section = event.target.closest('[data-hair-carousel]');
  if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
    event.preventDefault();
    gmyMoveHairSlide(section, event.key === 'ArrowLeft' ? -1 : 1);
  }
});
const gmyHairTouchStarts = new WeakMap();
document.addEventListener('pointerdown', event => {
  const section = event.target.closest('[data-hair-carousel]');
  if (!section || !event.target.closest('.gmy-texture-media')) return;
  gmyHairTouchStarts.set(section, { x: event.clientX, y: event.clientY, id: event.pointerId });
});
document.addEventListener('pointerup', event => {
  const section = event.target.closest('[data-hair-carousel]');
  if (!section) return;
  const start = gmyHairTouchStarts.get(section);
  gmyHairTouchStarts.delete(section);
  if (!start || start.id !== event.pointerId) return;
  const dx = event.clientX - start.x;
  const dy = event.clientY - start.y;
  if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) gmyMoveHairSlide(section, dx < 0 ? 1 : -1);
});
document.addEventListener('pointercancel', event => {
  const section = event.target.closest('[data-hair-carousel]');
  if (section) gmyHairTouchStarts.delete(section);
});
document.addEventListener('shopify:block:select', event => {
  const slide = event.target.closest('[data-hair-slide]');
  if (!slide) return;
  const section = slide.closest('[data-hair-carousel]');
  const index = Array.from(section.querySelectorAll('[data-hair-slide]')).indexOf(slide);
  gmyShowHairSlide(section, index);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gmy-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  function mount() {
    const configElement = document.getElementById('gmy-config');
    if (!configElement || configElement.dataset.mounted) return;
    configElement.dataset.mounted = 'true';
    const config = JSON.parse(configElement.textContent);
    const $ = (selector) => document.querySelector(selector);
    const controller = new AbortController();
    const on = (element, event, fn) => element?.addEventListener(event, fn, { signal: controller.signal });
    const inlineVideos = [...document.querySelectorAll('.gmy-inline-video video')];
    const visibleVideos = new Set();
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const mobileVideos = matchMedia('(max-width: 640px)');
    const videoStates = new Map();
    const canAutoplay = video => (!mobileVideos.matches || videoStates.get(video).index < 3) && !reducedMotion.matches && !navigator.connection?.saveData;
    const shouldPlay = video => {
      const state = videoStates.get(video);
      return !controller.signal.aborted && visibleVideos.has(video) && !document.hidden && state.choice !== 'paused' && (state.choice === 'manual' || canAutoplay(video));
    };
    const updateVideoControls = video => {
      const state = videoStates.get(video);
      const playing = !video.paused && !video.ended;
      state.wrapper.dataset.playing = String(playing);
      state.wrapper.dataset.muted = String(video.muted);
      if (playing) state.wrapper.dataset.started = 'true';
      [[state.toggle, playing || state.pending ? 'Pause' : 'Play'], [state.sound, video.muted ? 'Unmute' : 'Mute']].forEach(([button, action]) => {
        if (!button) return;
        const label = `${action} video ${state.index + 1}`;
        button.setAttribute('aria-label', label);
        button.title = label;
      });
    };
    const syncVideo = video => {
      const state = videoStates.get(video);
      video.loop = canAutoplay(video);
      if (!shouldPlay(video)) {
        video.pause();
      } else if (video.paused && !state.pending) {
        state.pending = true;
        let interrupted = false;
        video.play().catch(error => {
          if (error.name === 'AbortError') interrupted = true;
          else state.choice = 'paused';
        }).finally(() => {
          state.pending = false;
          if (!shouldPlay(video)) video.pause();
          else if (interrupted) syncVideo(video);
          updateVideoControls(video);
        });
      }
      updateVideoControls(video);
    };
    const videoObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.15) visibleVideos.add(entry.target);
        else visibleVideos.delete(entry.target);
        syncVideo(entry.target);
      });
    }, { threshold: [0, 0.15] });
    inlineVideos.forEach((video, index) => {
      const wrapper = video.closest('.gmy-inline-video');
      const controls = wrapper.querySelector('.gmy-video-controls');
      const toggle = wrapper.querySelector('[data-video-toggle]');
      const sound = wrapper.querySelector('[data-video-sound]');
      videoStates.set(video, { index, wrapper, toggle, sound, choice: 'auto', pending: false });
      if (controls && toggle) {
        video.controls = false;
        controls.hidden = false;
        const revealControls = () => {
          const state = videoStates.get(video);
          clearTimeout(state.controlsTimer);
          wrapper.dataset.controlsVisible = 'true';
          state.controlsTimer = setTimeout(() => {
            delete wrapper.dataset.controlsVisible;
          }, 3000);
        };
        const togglePlayback = () => {
          const state = videoStates.get(video);
          state.choice = !video.paused || state.pending ? 'paused' : 'manual';
          syncVideo(video);
          revealControls();
        };
        on(toggle, 'click', togglePlayback);
        on(video, 'click', revealControls);
        on(sound, 'click', () => {
          if (video.muted) inlineVideos.forEach(other => { if (other !== video) other.muted = true; });
          video.muted = !video.muted;
          updateVideoControls(video);
          revealControls();
        });
      }
      ['play', 'pause', 'volumechange'].forEach(event => on(video, event, () => updateVideoControls(video)));
      on(video, 'ended', () => {
        videoStates.get(video).choice = 'paused';
        updateVideoControls(video);
      });
      syncVideo(video);
      videoObserver.observe(video);
    });
    on(document, 'visibilitychange', () => inlineVideos.forEach(syncVideo));
    on(reducedMotion, 'change', () => inlineVideos.forEach(syncVideo));
    on(mobileVideos, 'change', () => inlineVideos.forEach(syncVideo));
    on(navigator.connection, 'change', () => inlineVideos.forEach(syncVideo));
    const ticker = $('#trust-ticker');
    const tickerToggle = ticker?.querySelector('.gmy-trust-ticker-toggle');
    if (tickerToggle) {
      tickerToggle.hidden = false;
      const pauseTicker = paused => {
        ticker.dataset.paused = String(paused);
        tickerToggle.setAttribute('aria-pressed', String(paused));
        const label = paused ? 'Resume scrolling' : 'Pause scrolling';
        tickerToggle.setAttribute('aria-label', label);
        tickerToggle.title = label;
      };
      on(tickerToggle, 'click', () => pauseTicker(ticker.dataset.paused !== 'true'));
    }
    const root = config.root.replace(/\/?$/, '/');
    let moneyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: config.currency });
    const money = cents => moneyFormatter.format(cents / 100);
    const decode = (text) => { const el = document.createElement('textarea'); el.innerHTML = text; return el.value; };
    const variants = new Map(config.variants.map(v => [String(v.id), { ...v, name: decode(v.name) }]));
    const normalizePrices = () => {
      document.querySelectorAll('[data-gmy-money]').forEach(el => { el.textContent = money(Number(el.dataset.gmyMoney)); });
    };
    normalizePrices();
    on(document, 'shopify:section:load', normalizePrices);
    on($('#gmy-mobile-set'), 'change', event => {
      const radio = document.querySelector('input[name="id"][value="' + event.target.value + '"]');
      if (radio && !radio.disabled) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    let busy = false;
    let cartState = null;
    let above = false;
    let slide = 0;
    const selected = () => variants.get($('input[name="id"]:checked')?.value);
    const quantity = () => Math.max(1, Math.min(20, Math.floor(Number($('#quantity').value) || 1)));
    const announce = text => { $('#live-region').textContent = text; };
    const syncSticky = () => { $('#sticky-purchase').hidden = !above || !!$('dialog[open]'); };
    const stickySize = new ResizeObserver(([entry]) => {
      if (entry.target.hidden) return;
      document.body.style.setProperty('--gmy-sticky-height', `${Math.ceil(entry.target.getBoundingClientRect().height)}px`);
    });
    stickySize.observe($('#sticky-purchase'));
    const syncDialogs = () => { document.body.classList.toggle('dialog-open', !!$('dialog[open]')); syncSticky(); };
    function openDialog(dialog) {
      document.querySelectorAll('dialog[open]').forEach(el => { if (el !== dialog) el.close(); });
      if (!dialog.open) dialog.showModal();
      syncDialogs();
    }
    document.querySelectorAll('dialog').forEach(dialog => {
      on(dialog, 'close', () => { dialog.querySelectorAll('video').forEach(video => video.pause()); syncDialogs(); });
      on(dialog.querySelector('[data-close-dialog]'), 'click', () => dialog.close());
      on(dialog, 'click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if(event.clientX<box.left || event.clientX>box.right || event.clientY<box.top || event.clientY>box.bottom) dialog.close();
      });
    });
    function syncSelection() {
      const variant = selected();
      $('#gmy-mobile-set').value = variant ? String(variant.id) : '';
      const mobileOption = $('#gmy-mobile-set').selectedOptions[0];
      $('#gmy-mobile-set-includes').textContent = mobileOption?.dataset.includes || '';
      $('#gmy-mobile-set-badge').textContent = mobileOption?.dataset.badge || '';
      $('#gmy-mobile-set-badge').hidden = !mobileOption?.dataset.badge;
      document.querySelectorAll('.gmy-mobile-set-picker,.gmy-offer,.sticky-purchase').forEach(element => {
        element.dataset.selectedVariant = variant ? String(variant.id) : '';
      });
      $('#quantity').value = quantity();
      $('#quantity-minus').disabled = quantity() <= 1;
      $('#quantity-plus').disabled = quantity() >= 20;
      $('#add-price').textContent = variant ? money(variant.price * quantity()) : '';
      $('#sticky-name').textContent = variant?.name || 'Unavailable';
      $('#sticky-price').textContent = variant ? money(variant.price * quantity()) : '';
      const discounted = variant && variant.compareAt > variant.price;
      if (!$('#sticky-image').dataset.fixedImage) {
        $('#sticky-image').hidden = !variant?.image;
        if (variant?.image) $('#sticky-image').src = variant.image;
      }
      $('#sticky-compare').hidden = !discounted;
      $('#sticky-discount').hidden = !discounted;
      $('#sticky-compare').textContent = discounted ? money(variant.compareAt * quantity()) : '';
      $('#sticky-discount').textContent = discounted ? `${config.saveBadge} ${Math.floor((variant.compareAt - variant.price) / variant.compareAt * 100)}%` : '';
      const currentPrice = $('#gmy-current-price');
      if (currentPrice) {
        currentPrice.textContent = variant ? money(variant.price) : '';
        $('#gmy-compare-price').hidden = !discounted;
        $('#gmy-discount').hidden = !discounted;
        if (discounted) {
          $('#gmy-compare-price').textContent = money(variant.compareAt);
          $('#gmy-discount').textContent = `${config.saveBadge} ${Math.floor((variant.compareAt - variant.price) / variant.compareAt * 100)}%`;
        }
      }
      document.querySelectorAll('.add-to-bag').forEach(button => { button.disabled = busy || !variant?.available; });
      if(variant) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }
    document.querySelectorAll('input[name="id"]').forEach(input => on(input, 'change', () => { syncSelection(); showSlide(selected()?.galleryIndex ?? 0); }));
    on($('#quantity'), 'change', syncSelection);
    on($('#quantity-minus'), 'click', () => { $('#quantity').value=quantity()-1;syncSelection(); });
    on($('#quantity-plus'), 'click', () => { $('#quantity').value=quantity()+1;syncSelection(); });
    on(document, 'click', event => {
      const button=event.target.closest('.choose-set');
      if(!button || busy) return;
      if(button.dataset.directAdd==='true'){add(event,variants.get(String(button.dataset.variant)),1);return;}
      const input=document.querySelector(`input[name="id"][value="${button.dataset.variant}"]`);
      if(!input || input.disabled) return;
      input.checked=true;syncSelection();showSlide(selected()?.galleryIndex ?? 0);input.focus({preventScroll:true});
      $('.variant-picker').scrollIntoView({behavior:'smooth',block:'center'});
    });
    const badge = count => {
      document.querySelectorAll('.cart-count').forEach(el=>{el.textContent=count;el.hidden=!count;});
      document.querySelectorAll('.cart-trigger').forEach(el=>el.setAttribute('aria-label',`Open bag, ${count} items`));
      $('#drawer-count').textContent=`(${count})`;
    };
    async function request(endpoint, data) {
      const response=await fetch(root+endpoint,{method:data?'POST':'GET',headers:{'Accept':'application/json',...(data?{'Content-Type':'application/json'}:{})},...(data?{body:JSON.stringify(data)}:{}),credentials:'same-origin'});
      const result=await response.json();
      if(!response.ok) throw new Error(typeof result.description==='string'?result.description:typeof result.message==='string'?result.message:'Something went wrong. Please try again.');
      return result;
    }
    function error(message,target='cart-error') { const el=document.getElementById(target);el.textContent=message;el.hidden=!message; }
    function element(tag, className, text) { const el=document.createElement(tag);if(className)el.className=className;if(text!==undefined)el.textContent=text;return el; }
    function renderCart(data) {
      cartState=data;
      if (config.currency !== data.currency) {
        config.currency = data.currency;
        moneyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: config.currency });
      }
      badge(data.item_count);
      $('#cart-dialog').dataset.hasTreatment=String(data.items.some(item=>variants.has(String(item.variant_id))));
      const content=$('#cart-content');content.replaceChildren();
      $('#cart-bottom').hidden=!data.item_count;
      if(!data.item_count){
        const empty=element('div','cart-empty');empty.append(element('h3','', 'Your next good hair day starts here.'),element('p','', 'Your bag is waiting for a little glow.'));
        const back=element('button','button button-primary','Explore the treatment');back.type='button';back.onclick=()=>{$('#cart-dialog').close();$('#product').scrollIntoView({behavior:'smooth'});};empty.append(back);content.append(empty);return;
      }
      data.items.forEach(item=>{
        const variant=variants.get(String(item.variant_id));
        const name=variant?.name || item.product_title || item.title;
        const row=element('article','cart-item');const media=element('div','cart-item-media');
        const imageUrl=variant?.image || item.featured_image?.url || item.image;
        if(imageUrl){const image=element('img');image.src=imageUrl;image.alt=name;image.loading='lazy';media.append(image);}else media.textContent='GMH';
        const body=element('div');const title=element('div','cart-item-title');title.append(element('h3','',name));
        const remove=element('button','icon-button','\u00d7');remove.type='button';remove.setAttribute('aria-label',`Remove ${name}`);remove.title='Remove item';remove.dataset.key=item.key;remove.dataset.quantity=0;
        title.append(remove);body.append(title,element('p','',`${money(item.final_price)} each`));
        const controls=element('div','cart-item-controls');const stepper=element('div','quantity-control');
        for(const [label,value,visible] of [['Decrease',item.quantity-1,'\u2212'],['Increase',item.quantity+1,'+']]){
          const button=element('button','',visible);button.type='button';button.setAttribute('aria-label',`${label} ${name} quantity`);button.title=`${label} quantity`;button.dataset.key=item.key;button.dataset.quantity=value;button.disabled=busy;stepper.append(button);
          if(label==='Decrease') stepper.append(element('span','',String(item.quantity)));
        }
        controls.append(stepper);const price=element('strong');if(item.original_line_price>item.final_line_price)price.append(element('span','cart-item-original',money(item.original_line_price)));price.append(document.createTextNode(money(item.final_line_price)));controls.append(price);body.append(controls);row.append(media,body);content.append(row);
      });
      $('#cart-subtotal').textContent=money(data.total_price);
    }
    function setBusy(value){busy=value;syncSelection();document.querySelectorAll('.gmy-bundle-add').forEach(el=>{el.disabled=value||el.dataset.available!=='true';el.setAttribute('aria-busy',String(value));});$('#cart-dialog').setAttribute('aria-busy',String(value));document.querySelectorAll('#cart-content button,#checkout-button').forEach(el=>{el.disabled=value;});}
    async function showCart(){
      if(busy)return;openDialog($('#cart-dialog'));error('');$('#cart-content').replaceChildren(element('p','cart-loading','Loading your bag...'));$('#cart-bottom').hidden=true;setBusy(true);
      try{renderCart(await request('cart.js'));}catch(e){$('#cart-content').replaceChildren(element('p','gmy-error',e.message));const retry=element('button','button button-outline','Try again');retry.onclick=showCart;$('#cart-content').append(retry);}finally{setBusy(false);}
    }
    document.querySelectorAll('.cart-trigger').forEach(button=>on(button,'click',showCart));
    on(document,'click',event=>{if(event.target.closest('a.gmy-cart-link'))$('#cart-dialog').close();});
    async function add(event,variant=selected(),amount=quantity()){
      event.preventDefault();if(busy || !variant?.available)return;error('','product-error');if($('#gmy-bundle-error'))error('','gmy-bundle-error');setBusy(true);
      try{
        await request('cart/add.js',{items:[{id:variant.id,quantity:amount}]});
        const data=await request('cart.js');renderCart(data);openDialog($('#cart-dialog'));error('');announce(`${variant.name} added to your bag.`);
      }catch(e){error(e.message,'product-error');if($('#gmy-bundle-error'))error(e.message,'gmy-bundle-error');announce(e.message);}finally{setBusy(false);}
    }
    on($('#gmy-product-form'),'submit',add);
    on($('#sticky-purchase .add-to-bag'),'click',add);
    on($('#cart-content'),'click',async event=>{
      const button=event.target.closest('button[data-key]');if(!button || busy)return;const key=button.dataset.key;const next=Number(button.dataset.quantity);error('');setBusy(true);
      try{renderCart(await request('cart/change.js',{id:key,quantity:next}));announce('Your bag has been updated.');}
      catch(e){error(e.message);try{renderCart(await request('cart.js'));}catch{}}
      finally{setBusy(false);const target=[...document.querySelectorAll('#cart-content button[data-key]')].find(el=>el.dataset.key===key) || $('#cart-content button') || $('#cart-dialog [data-close-dialog]');target?.focus({preventScroll:true});}
    });
    on($('#checkout-button'),'click',()=>{if(!busy && cartState?.item_count) location.href=root+'checkout';});
    on($('#menu-toggle'),'click',()=>openDialog($('#menu-dialog')));
    document.querySelectorAll('#menu-dialog nav a').forEach(a=>on(a,'click',()=>$('#menu-dialog').close()));
    function showSlide(index){
      const panels=[...document.querySelectorAll('[data-gallery-panel]')];slide=(index+panels.length)%panels.length;
      if(!panels.length)return;
      panels.forEach((panel,i)=>{panel.hidden=i!==slide;});
      document.querySelectorAll('[data-slide]').forEach(button=>{const active=button.dataset.slide===panels[slide].dataset.galleryPanel;button.classList.toggle('selected',active);button.setAttribute('aria-pressed',String(active));});
      if($('#gallery-current'))$('#gallery-current').textContent=String(slide+1);
    }
    document.querySelectorAll('[data-slide]').forEach(button=>on(button,'click',()=>showSlide([...document.querySelectorAll('[data-gallery-panel]')].findIndex(panel=>panel.dataset.galleryPanel===button.dataset.slide))));
    let touch=null;
    on($('#gallery-main'),'touchstart',e=>{touch={x:e.changedTouches[0].clientX,y:e.changedTouches[0].clientY};});
    on($('#gallery-main'),'touchend',e=>{if(!touch)return;const x=e.changedTouches[0].clientX-touch.x,y=e.changedTouches[0].clientY-touch.y;if(Math.abs(x)>45 && Math.abs(x)>Math.abs(y))showSlide(slide+(x<0?1:-1));touch=null;});
    on($('#gallery-zoom'),'click',()=>{
      $('#media-dialog-title').textContent='Product image';$('#media-container').replaceChildren(document.querySelectorAll('[data-gallery-panel]')[slide].cloneNode(true));$('#media-container').firstElementChild.hidden=false;openDialog($('#media-dialog'));
    });
    on(document,'input',event=>{if(event.target.id==='comparison-range')$('#comparison')?.style.setProperty('--split',`${event.target.value}%`);});
    const observer=new IntersectionObserver(([entry])=>{above=!entry.isIntersecting;syncSticky();},{threshold:0});observer.observe($('#purchase-row'));
    const cleanup=event=>{if(event.target.contains(configElement)){controller.abort();observer.disconnect();stickySize.disconnect();videoObserver.disconnect();inlineVideos.forEach(video=>{clearTimeout(videoStates.get(video).controlsTimer);video.pause();});document.body.classList.remove('dialog-open');document.removeEventListener('shopify:section:unload',cleanup);}};
    document.addEventListener('shopify:section:unload',cleanup);
    badge(config.cartCount);syncSelection();showSlide(selected()?.galleryIndex ?? 0);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
  document.addEventListener('shopify:section:load',mount);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gmy-reviews"] && !Shopify.designMode) return;
  try {
    
function setReviewExpansion(button, expanded) {
  const wall = button.closest('.gmy-review-wall');
  if (!wall) return;
  wall.querySelectorAll('[data-review-extra]').forEach(card => { card.hidden = !expanded; });
  button.setAttribute('aria-expanded', String(expanded));
  button.querySelector('[data-review-toggle-label]').textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel;
}
document.addEventListener('click', event => {
  const button = event.target.closest('[data-review-toggle]');
  if (!button) return;
  const expanded = button.getAttribute('aria-expanded') !== 'true';
  setReviewExpansion(button, expanded);
  if (!expanded) button.scrollIntoView({ block: 'center' });
});
document.addEventListener('shopify:block:select', event => {
  const card = event.target.closest('[data-review-extra]');
  if (!card || !card.hidden) return;
  const button = card.closest('.gmy-review-wall').querySelector('[data-review-toggle]');
  if (button) {
    setReviewExpansion(button, true);
    card.scrollIntoView({ block: 'center' });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-collection"] && !Shopify.designMode) return;
  try {
    
  tabs= document.querySelectorAll('.custom-tab');
  tabContents= document.querySelectorAll('.custom__tab-content');

  tabs.forEach(function(tab){
      tab.addEventListener('click',function(){

          contentId = this.dataset.contentId;
          content = document.getElementById(contentId);

          tabContents.forEach(function(content){
              content.classList.remove('active');
          });

          tabs.forEach(function(tab){
              tab.classList.remove('active');
          });

          this.classList.add('active');
          content.classList.add('active');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  tabs= document.querySelectorAll('.custom-tab');
  tabContents= document.querySelectorAll('.custom__tab-content');

  tabs.forEach(function(tab){
      tab.addEventListener('click',function(){

          contentId = this.dataset.contentId;
          content = document.getElementById(contentId);

          tabContents.forEach(function(content){
              content.classList.remove('active');
          });

          tabs.forEach(function(tab){
              tab.classList.remove('active');
          });

          this.classList.add('active');
          content.classList.add('active');
      });
  });

  } catch(e) { console.error(e); }
})();
})();
